import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=4f83c7fb&"
import script from "./TaskModal.vue?vue&type=script&lang=ts&"
export * from "./TaskModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports